import axios from 'axios';

const Api = axios.create({
  baseURL: window.appBaseUrl,
  withCredentials: true,
  headers: {
    'Content-type': 'application/json',
  },
});

Api.interceptors.response.use((res) => {
  return traitResponse(res.data)
}, (error) => {
  traitResponse(error.response.data)
})

const traitResponse = (res) => {
  if (typeof (res?.response?.code) == 'undefined' || typeof (res?.response?.msg) == 'undefined' || typeof (res?.data) == 'undefined') {
    window.$.fn.msg('Atenção!', window.$.fn.msgType('danger', 'Erro interno no servidor'))
    return false
  }

  if (res.response.code !== 0) {
    window.$.fn.msg('Atenção!', window.$.fn.msgType('danger', res.response.msg));
    return false;
  }

  return res;
}

export default Api;
